import React from "react";
import { string, arrayOf, shape } from "prop-types";
import EventInfo from "../../atoms/EventInfo";

import "./event-info-block.m.css";

const EventInfoBlock = ({ label, title, details, storyUrl, storyTemplate, eventForum, eventWhen, ...props }) => {
  return (
    <div styleName="event-info-block" {...props}>
      {title && (
        <EventInfo
          variant="title"
          onClick={storyUrl ? () => window.open(storyUrl, '_blank') : undefined}
          style={storyUrl ? { cursor: 'pointer', textDecoration: 'none' } : undefined}
          onMouseEnter={storyUrl ? (e) => e.target.style.textDecoration = 'underline' : undefined}
          onMouseLeave={storyUrl ? (e) => e.target.style.textDecoration = 'none' : undefined}
        >
          {title}
        </EventInfo>
      )}
      {storyTemplate === "session" && (eventWhen || eventForum) && (
        <div styleName="session-info">
          <span styleName="session-date">{eventWhen}</span>
          {eventWhen && eventForum && <span styleName="session-separator">&nbsp;|&nbsp;</span>}
          <span styleName="session-forum">{eventForum}</span>
        </div>
      )}
      {details?.map((detail, index) => (
        <EventInfo key={index} variant="info">{detail}</EventInfo>
      ))}
    </div>
  );
};

EventInfoBlock.propTypes = {
  label: string,
  title: string,
  details: arrayOf(string),
  storyUrl: string,
  storyTemplate: string,
  eventForum: string,
  eventWhen: string
};

export default EventInfoBlock;